// extracted by mini-css-extract-plugin
export var item = "index-module--item--3SjEH";
export var container = "index-module--container--7XnqP";
export var card = "index-module--card--3cunT";
export var inner = "index-module--inner--38Zh7";
export var icon_container = "index-module--icon_container--mhqdc";
export var content = "index-module--content--1ZQ6z";